/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import { t_rec_arr, t_partition } from '../types';
import is_array from '../is/is_array';
import concat from '../array/concat';
import merge from '../record/merge';

export interface Unpartition {
  /**
   * @public
   * @function f1.unpartition
   * @see f1.partition
   * @param partition the partition used by f1.partition
   * @example
   *
   * ```ts
   * f1.unpartition([[16, 17], [18]]) === [16, 17, 18]
   * ```
   *
   */
  <V>(partition: t_partition<V>): t_rec_arr<V>;
}

/**
 * @see Unpartition
 */
export default <V>(partition: t_partition<V>): t_rec_arr<V> => {
  const sample = partition[0] || partition[1];

  return is_array(sample)
    ? concat(partition[0] as V[], partition[1] as V[])
    : (merge('onto', partition[0], partition[1]) as t_rec_arr<V>);
};
